module.exports = __webpack_public_path__ + "img/mainmenu-ar.22629403.png";